import OutOfStockReportSummary from './summary/indexContainer';
import OutOfStockReportDetailed from './detailed/indexContainer';

export {
    OutOfStockReportSummary,
    OutOfStockReportDetailed
}